import { backend } from "@/.config";
import { DisplaySetting } from "@/store/schemas";
import { KeyAnyValue } from "@/store/types";
import { notEmptyString } from "./validators";

export const displaySvgs = [
  'featured-image-cover--false.svg',
  'featured-image-cover--true.svg',
  'student-info--top.svg',
  'student-info--bottom.svg',
  'container-width--half.svg',
  'container-width--full.svg',
  'container-width--boxed.svg',
  'image-text--below.svg',
  'image-text--left.svg',
  'image-text--right.svg',
  'image-text--above.svg',
  'text-alignment--left.svg',
  'text-alignment--centred.svg',
  'text-alignment--right.svg',
  'image-width--double.svg',
  'image-width--single.svg',
  'image-width--cover.svg',
  'grid--masonry.svg',
  'grid--row.svg',
];

export const displaySvgNameMap = {
  student_info: 'student-info',
  featured_image_cover: 'featured-image-cover',
  media_image_text_position: 'image-text',
  media_image_text_alignment: 'text-alignment',
  work_row: 'grid',
  media_layout: 'image-width',
  work_info_width: 'container-width'
}

export const matchDisplaySVG = (setting: DisplaySetting, values: KeyAnyValue[] = [], index = 0): string => {
  const prefix = Object.keys(displaySvgNameMap).includes(setting.key) ? displaySvgNameMap[setting.key] : '';
  const value  = index >= 0 && index < values.length ? values[index].value : null;
  const hasValue = value !== null;
  const strVal = setting.type === 'boolean'? value === true? 'true' : 'false' : hasValue ? typeof value === 'string'? value : value.toString() : '';
  return notEmptyString(prefix) && hasValue ? [prefix, strVal].join('--') + '.svg' : '';
}

export const  hasDisplaySVG = (setting: DisplaySetting, values: KeyAnyValue[] = [], index = 0): boolean => {
  const svg = matchDisplaySVG(setting, values, index);
  return svg.length > 5 && displaySvgs.includes(svg);
}

export const displaySvgPath = (filename = '') => {
  return backend.mediaPath.replace('/media', '/drawings') + filename;
}